/* Interactions nofame : carousel héro et compte à rebours de drop. Vanilla, sans dépendance. */
(function () {
  'use strict';

  /* ---------- Carousel ---------- */
  if (!customElements.get('nofame-carousel')) {
    class NofameCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.index = 0;
        this.count = this.slides.length;
        if (this.count <= 1) return;

        /* Mode « fluide » : plusieurs vignettes visibles, défilement d'une vignette
           à la fois. Les largeurs viennent du CSS, le JS ne fait que les lire. */
        this.fluid = this.hasAttribute('data-fluid');
        this.viewport = this.querySelector('[data-carousel-viewport]') || (this.track && this.track.parentElement);
        if (this.fluid && window.ResizeObserver) {
          this.ro = new ResizeObserver(() => this.render());
          this.ro.observe(this.viewport);
        }

        this.autoplayMs = parseInt(this.dataset.autoplay || '0', 10);
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('[data-carousel-prev]').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index - 1, true))
        );
        this.querySelectorAll('[data-carousel-next]').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index + 1, true))
        );
        this.dots.forEach((dot, i) =>
          dot.addEventListener('click', () => this.go(i, true))
        );

        this.render();
        this.startAuto();

        this.addEventListener('mouseenter', () => this.stopAuto());
        this.addEventListener('mouseleave', () => this.startAuto());
        this.addEventListener('focusin', () => this.stopAuto());
        this.addEventListener('focusout', () => this.startAuto());
      }

      disconnectedCallback() {
        this.stopAuto();
        if (this.ro) this.ro.disconnect();
      }

      /* Nombre de vignettes réellement visibles, déduit des largeurs rendues. */
      perView() {
        if (!this.fluid || !this.viewport || this.count < 2) return 1;
        const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        if (step <= 0) return 1;
        return Math.max(1, Math.min(this.count, Math.round(this.viewport.clientWidth / step)));
      }

      lastIndex() {
        return Math.max(0, this.count - this.perView());
      }

      go(i, manual) {
        const last = this.lastIndex();
        if (this.fluid) {
          if (i > last) i = 0;
          else if (i < 0) i = last;
          this.index = i;
        } else {
          this.index = ((i % this.count) + this.count) % this.count;
        }
        this.render();
        if (manual) this.startAuto();
      }

      render() {
        if (this.track) {
          if (this.fluid) {
            if (this.index > this.lastIndex()) this.index = this.lastIndex();
            const step = this.count > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : 0;
            this.track.style.transform = 'translateX(-' + this.index * step + 'px)';
          } else {
            this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
          }
        }
        const visible = this.perView();
        this.slides.forEach((s, i) => {
          const on = i >= this.index && i < this.index + visible;
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        this.dots.forEach((d, i) => {
          const on = i === this.index;
          d.classList.toggle('is-active', on);
          if (on) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        /* Barre de progression : le remplissage couvre les vignettes visibles.
           Le décalage est exprimé en % de ce remplissage, donc un cran de carousel
           (une vignette) vaut 100 / visible pour cent de sa largeur. */
        const bar = this.querySelector('[data-carousel-progress]');
        if (bar && visible > 0) {
          bar.style.width = (visible * 100) / this.count + '%';
          bar.style.transform = 'translateX(' + (this.index * 100) / visible + '%)';
        }
      }

      startAuto() {
        this.stopAuto();
        if (!this.autoplayMs || this.reduced) return;
        this.timer = setInterval(() => this.go(this.index + 1, false), this.autoplayMs);
      }

      stopAuto() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
    }
    customElements.define('nofame-carousel', NofameCarousel);
  }

  /* ---------- Fenêtres modales ----------
     Délégation sur le document : les boutons peuvent apparaître n'importe où et
     à n'importe quel moment (rechargement de section dans le personnalisateur). */
  const lockScroll = () => document.documentElement.classList.add('nf-modal-open');
  const unlockScroll = () => {
    if (!document.querySelector('dialog.nf-modal[open]')) {
      document.documentElement.classList.remove('nf-modal-open');
    }
  };

  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-nf-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-nf-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
        lockScroll();
        /* Pas de focus automatique sur mobile : il déclenche le clavier, qui
           réduit la fenêtre visuelle et fait sauter toute la mise en page. */
        const field = dialog.querySelector('input[type="email"]');
        if (field && window.matchMedia('(min-width: 750px)').matches) {
          field.focus();
        } else {
          const panel = dialog.querySelector('.nf-modal__panel');
          if (panel) panel.focus();
        }
      }
      return;
    }

    const closer = event.target.closest('[data-nf-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    /* Clic sur le fond : la cible est alors le <dialog> lui-même, le contenu
       étant dans un panneau enfant. */
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('nf-modal')) {
      event.target.close();
    }
  });

  /* close() couvre aussi la fermeture par Échap, qui ne passe pas par le clic. */
  document.addEventListener('close', function (event) {
    if (event.target instanceof HTMLDialogElement) unlockScroll();
  }, true);

  /* ---------- Countdown ---------- */
  if (!customElements.get('nofame-countdown')) {
    class NofameCountdown extends HTMLElement {
      connectedCallback() {
        /* Drop en cours : fenêtre de la réduction automatique, posée par
           scripts/drop-bandeau.mjs. Deux panneaux, un seul visible. Chaque
           panneau a son propre compteur : celui de l'attente vient du panneau
           d'attente, pas du premier venu dans le DOM. */
        this.waitPanel = this.querySelector('[data-mode="wait"]');
        this.dropPanel = this.querySelector('[data-mode="drop"]');
        this.display = (this.waitPanel || this).querySelector('[data-countdown-display]');
        if (!this.display) return;
        this.fixed = this.dataset.targetDate ? new Date(this.dataset.targetDate) : null;
        this.dow = parseInt(this.dataset.dow || '0', 10); // 0=dimanche
        this.hour = parseInt(this.dataset.hour || '20', 10);
        this.dropDisplay = this.dropPanel ? this.dropPanel.querySelector('[data-countdown-display]') : null;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      dropWindow() {
        const start = this.dataset.dropStart ? new Date(this.dataset.dropStart) : null;
        const end = this.dataset.dropEnd ? new Date(this.dataset.dropEnd) : null;
        if (!start || !end || isNaN(start) || isNaN(end)) return null;
        return { start, end };
      }

      format(diff) {
        const pad = (n) => String(n).padStart(2, '0');
        const d = Math.floor(diff / 86400000); diff -= d * 86400000;
        const h = Math.floor(diff / 3600000); diff -= h * 3600000;
        const m = Math.floor(diff / 60000); diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        /* Sous 24 heures, le segment des jours ne dit plus rien : on l'enlève
           plutôt que d'afficher un 00j. Le verrouillage se fait souvent le jour
           même, c'est ce cas là qui doit être lisible. */
        const parts = [];
        if (d > 0) parts.push(pad(d) + 'j');
        parts.push(pad(h) + 'h', pad(m) + 'm', pad(s) + 's');
        return parts.join(' ');
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      nextTarget(now) {
        if (this.fixed && !isNaN(this.fixed)) return this.fixed;
        const target = new Date(now);
        target.setHours(this.hour, 0, 0, 0);
        let add = (this.dow - target.getDay() + 7) % 7;
        if (add === 0 && target.getTime() <= now.getTime()) add = 7;
        target.setDate(target.getDate() + add);
        return target;
      }

      tick() {
        const now = new Date();
        const win = this.dropWindow();
        const inDrop = !!(win && this.dropPanel && now >= win.start && now < win.end);
        if (this.waitPanel && this.dropPanel) {
          this.waitPanel.hidden = inDrop;
          this.dropPanel.hidden = !inDrop;
        }
        if (inDrop && this.dropDisplay) {
          this.dropDisplay.textContent = this.format(Math.max(0, win.end.getTime() - now.getTime()));
          return;
        }
        this.display.textContent = this.format(Math.max(0, this.nextTarget(now).getTime() - now.getTime()));
      }
    }
    customElements.define('nofame-countdown', NofameCountdown);
  }
})();
